const Alert = {
  variants: {
    darkSuccess: {
      container: {
        bg: "green.700",
        color: "white",
      },
    },
  },
};

export default Alert;
